import { render } from "./Welcome.vue?vue&type=template&id=12a51728"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=12a51728&lang=css"
script.render = render

export default script